import { Directive } from '@angular/core';
import AppValues from 'src/app/common/app.values';
import { PaginationResolver } from 'src/app/interfaces/pagination.interface';
import { SortingOrderType } from 'src/app/interfaces/search.interface';
import {
  DEFAULT_SORT_OPTIONS,
  getSortingOrderType,
  isAscendingIcon,
  NAME_SORT_OPTIONS,
  SortCategories,
  SortOptions,
} from 'src/app/views/sort-elements/sort-drop-down/sort-drop-down.helpers';
import { buildSorting } from '../../user-relation-requests/components/manage-relation-request/manage-relation-request.helper';
import { initialPaginationState } from '../social-initiative/social-initiative.helpers';

@Directive()
export abstract class SocialInvolvementContext {
  public readonly SORT_OPTIONS: SortOptions[] = DEFAULT_SORT_OPTIONS;
  public readonly NAME_SORT_OPTIONS: SortOptions[] = NAME_SORT_OPTIONS;

  public sorting: SortCategories = SortCategories.DATE_DESC;

  public currentSortCategory: SortingOrderType = SortingOrderType.DATE;
  public pageSize = AppValues.PAGE_LIMIT;
  public resolver: PaginationResolver = { state: initialPaginationState() };
  public ascending = false;

  public verifiedCounter = 0;
  public sentCounter = 0;
  public receivedCounter = 0;

  public isFormChanged = false;

  protected abstract subscribeOnCounterChanges(): void;
  protected abstract onListUpdate(): void;

  public onSortParamChanged(orderType: SortingOrderType): void {
    this.currentSortCategory = orderType;
    this.sorting = buildSorting(this.sorting, orderType);
    this.ascending = isAscendingIcon(this.sorting);
    this.onListUpdate();
  }

  public toggleSortingOrderByType(sortOptions: SortOptions): void {
    this.sorting = sortOptions.sortCategory;
    this.ascending = isAscendingIcon(sortOptions.sortCategory);
    this.currentSortCategory = getSortingOrderType(sortOptions.sortCategory);
    this.onListUpdate();
  }

  public resetSortingParameters(): void {
    this.currentSortCategory = SortingOrderType.DATE;
    this.ascending = false;
    this.sorting = SortCategories.DATE_DESC;
  }
}
